import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecommerce-dashboaard',
  templateUrl: './ecommerce-dashboaard.component.html',
  styleUrls: ['./ecommerce-dashboaard.component.css']
})
export class EcommerceDashboaardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
